'use client';

import React__default from 'react';
import { FooterContainer, CustomButton } from '../../styles.css.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import { useOnBoarding } from '../../context/index.js';
import LoadingIcon from '../../../Images/LoadingIcon/index.js';
import { colors } from '../../../Colors/index.js';
import { EStep } from '../../type.js';

var Footer = function (_a) {
    var onBack = _a.onBack, onContinue = _a.onContinue;
    var t = useTranslate().t;
    var _b = useOnBoarding(), isLoading = _b.isLoading, hash = _b.hash, setHash = _b.setHash;
    var onClickContinue = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        if (!onContinue)
            return;
        onContinue();
        switch (hashValue) {
            case EStep.PersonalInformatoion:
                setHash(EStep.HaveCV);
                break;
            case EStep.HaveCV:
                setHash(EStep.UploadCV);
                break;
            case EStep.UploadCV:
                setHash(EStep.BasicInformation);
                break;
            case EStep.BasicInformation:
                setHash(EStep.Skill);
                break;
            case EStep.Skill:
                setHash(EStep.WorkingPreference);
                break;
            case EStep.WorkingPreference:
                setHash(EStep.Recommendation);
                break;
            case EStep.Recommendation:
                setHash(EStep.Successfully);
                break;
        }
    };
    var onClickBack = function () {
        var hashValue = hash === null || hash === void 0 ? void 0 : hash.split('#').pop();
        if (!onBack)
            return;
        onBack();
        switch (hashValue) {
            case EStep.PersonalInformatoion:
                setHash(EStep.Welcome);
                break;
            case EStep.HaveCV:
                setHash(EStep.PersonalInformatoion);
                break;
            case EStep.UploadCV:
                setHash(EStep.HaveCV);
                break;
            case EStep.BasicInformation:
                setHash(EStep.UploadCV);
                break;
            case EStep.Skill:
                setHash(EStep.BasicInformation);
                break;
            case EStep.WorkingPreference:
                setHash(EStep.Skill);
                break;
            case EStep.Recommendation:
                setHash(EStep.WorkingPreference);
                break;
        }
    };
    return (React__default.createElement(FooterContainer, null,
        React__default.createElement(Row, { container: { md: 12 }, gutter: 12, justify: 'center' },
            React__default.createElement(Col, { xs: 12, sm: 'auto' },
                React__default.createElement(CustomButton, { onClick: onClickBack }, t('Back'))),
            React__default.createElement(Col, { xs: 12, sm: 'auto' },
                React__default.createElement(CustomButton, { type: 'primary', 
                    // disabled={resumeType === 'attachCV' && step === 3 ? !fileInfo?.name : false || isLoading}
                    onClick: onClickContinue },
                    isLoading && React__default.createElement(LoadingIcon, { bgColor: colors.grey[80] }),
                    " ",
                    t('Continue'))))));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
